"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _formWrapper = _interopRequireDefault(require("../../formWrapper.js"));
var _CardWrapper = _interopRequireDefault(require("./CardWrapper"));
var _Tile = _interopRequireDefault(require("./Tile"));
var _reorder = _interopRequireDefault(require("../../../helpers/reorder.js"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdColorPicker = require("cccisd-color-picker");
var _cccisdLaravelResources = require("cccisd-laravel-resources");
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _IconBase = _interopRequireDefault(require("cccisd-icons/dist/IconBase.js"));
var _generateNewId = require("../../../helpers/generateNewId.js");
var _plusCircle = _interopRequireDefault(require("cccisd-icons/plus-circle2"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var fields = ['title', 'description', 'primaryColor', 'secondaryColor', 'containers[]', 'containers[].id', 'containers[].title', 'containers[].description', 'containers[].tiles[]', 'containers[].tiles[].id', 'containers[].tiles[].content', 'containers[].tiles[].content.type', 'containers[].tiles[].content.handle', 'containers[].tiles[].text', 'containers[].tiles[].icon', 'containers[].tiles[].iconUrl', 'containers[].tiles[].tooltip'];
var validate = function validate(values, props) {
  var errors = {};
  return errors;
};
var ReportCenterForm = function ReportCenterForm(props) {
  var _props$fields = props.fields,
    title = _props$fields.title,
    description = _props$fields.description,
    containers = _props$fields.containers,
    primaryColor = _props$fields.primaryColor,
    secondaryColor = _props$fields.secondaryColor;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    collapsed = _useState2[0],
    setCollapsed = _useState2[1];
  var handleCollapse = function handleCollapse(id) {
    if (collapsed.includes(id)) {
      return setCollapsed(collapsed.filter(function (tabId) {
        return tabId !== id;
      }));
    }
    return setCollapsed([].concat(_toConsumableArray(collapsed), [id]));
  };
  var _onDragEnd = function onDragEnd(result, container) {
    var destination = result.destination,
      source = result.source;
    if (!destination) {
      return;
    }
    (0, _reorder["default"])(container.tiles, source.index, destination.index);
  };
  var getListStyle = function getListStyle(isDraggingOver) {
    return {
      overflow: 'auto',
      background: isDraggingOver && '#eee',
      padding: '0 0 0 5px'
    };
  };
  var handleAddTile = function handleAddTile(values, container, closeModal) {
    var containerSettings = props.settings.containers.find(function (c) {
      return c.id === container.id.value;
    });
    container.tiles.addField({
      id: (0, _generateNewId.generateNewId)({
        prefix: 'reportTile',
        settings: containerSettings.tiles
      }),
      text: values.text,
      icon: values.icon,
      iconUrl: values.iconUrl,
      content: {
        type: values.type,
        handle: values.content
      },
      tooltip: values.tooltip
    });
    closeModal();
  };
  var addTileValidate = function addTileValidate(values) {
    var errors = {};
    if (!values.text) {
      errors.text = 'You must enter a name.';
    }
    if (!values.icon) {
      errors.icon = 'You must make a selection.';
    }
    if (!values.type) {
      errors.type = 'You must make a selection.';
    }
    if (!values.content) {
      errors.content = 'You must make a selection.';
    }
    if (values.icon === 'url' && !values.iconUrl) {
      errors.iconUrl = 'You must upload an image.';
    }
    return errors;
  };
  var tileTemplateTypeOptions = [{
    value: '',
    label: '-- Choose content type --'
  }, {
    value: 'report',
    label: 'Report'
  }, {
    value: 'table',
    label: 'Table'
  }];
  var _getTableOptions = function _getTableOptions() {
    var tables = props.tables;
    var options;
    if (tables.list) {
      options = tables.list.map(function (table) {
        return {
          value: table.id,
          label: table.id
        };
      });
      options.unshift({
        value: '',
        label: '-- Choose table --'
      });
    } else {
      options = [{
        value: null,
        label: 'No tables found'
      }];
    }
    return options;
  };
  var _getReportOptions = function _getReportOptions() {
    var reports = props.reports;
    var options;
    if (reports.list) {
      options = reports.list.map(function (report) {
        return {
          value: report.id,
          label: report.id
        };
      });
      options.unshift({
        value: '',
        label: '-- Choose report --'
      });
    } else {
      options = [{
        value: null,
        label: 'No reports found'
      }];
    }
    return options;
  };
  var handleAddContainer = function handleAddContainer(values, closeModal) {
    var containerSettings = props.settings.containers;
    containers.addField({
      id: (0, _generateNewId.generateNewId)({
        prefix: 'container',
        settings: containerSettings
      }),
      title: values.title,
      description: values.description,
      tiles: []
    });
    closeModal();
  };
  var addContainerValidate = function addContainerValidate(values) {
    var errors = {};
    if (!values.title) {
      errors.title = 'You must enter a title.';
    }
    if (!values.description) {
      errors.description = 'You must enter a description.';
    }
    return errors;
  };
  var iconOptions = props.icons.map(function (icon) {
    return {
      value: icon.id,
      label: /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].iconBox,
        style: icon.backgroundColor ? {
          backgroundColor: icon.backgroundColor
        } : {
          backgroundColor: icon.color
        }
      }, /*#__PURE__*/_react["default"].createElement("span", {
        style: icon.backgroundColor ? {
          color: icon.color,
          fontSize: '1.5em'
        } : {
          color: '#fff',
          fontSize: '1.5em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_IconBase["default"], {
        viewBox: icon.viewBox,
        key: icon.id
      }, /*#__PURE__*/_react["default"].createElement("g", null, icon.paths.map(function (p, index) {
        return /*#__PURE__*/_react["default"].createElement("path", {
          key: index,
          d: p
        });
      })))))
    };
  });
  iconOptions.push({
    value: 'url',
    label: /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].iconBox
    }, /*#__PURE__*/_react["default"].createElement("span", null, "Use Upload"))
  });
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].buttonRight
  }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    trigger: /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-primary",
      style: {
        marginBottom: '0.5em'
      }
    }, "Color Settings"),
    title: "Color Settings",
    render: function render(_ref) {
      var closeModal = _ref.closeModal;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: primaryColor,
        label: "Container Primary Color"
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.ColorPicker, {
        field: primaryColor
      }))), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: secondaryColor,
        label: "Container Secondary Color"
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.ColorPicker, {
        field: secondaryColor
      }))), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-default",
        onClick: function onClick() {
          closeModal();
        }
      }, "Ok"));
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].header
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].title
  }, /*#__PURE__*/_react["default"].createElement("h1", null, title.value), /*#__PURE__*/_react["default"].createElement("p", null, description.value)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].menu
  }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    title: "Page title and description",
    size: "large",
    trigger: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: "Add/Edit page title"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      title: /*#__PURE__*/_react["default"].createElement(_pencil["default"], null),
      className: "btn btn-success btn-xs"
    })),
    render: function render(_ref2) {
      var closeModal = _ref2.closeModal;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        label: "Title",
        field: title
      }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        label: "Description",
        field: description
      }), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-default",
        onClick: closeModal
      }, "Ok"));
    }
  }))), containers.map(function (container) {
    return /*#__PURE__*/_react["default"].createElement(_CardWrapper["default"], {
      key: container.id.value,
      title: container.title,
      description: container.description,
      id: container.id.value,
      containers: containers,
      handleCollapse: handleCollapse,
      collapsed: collapsed,
      primaryColor: (0, _cccisdColorPicker.getColor)(primaryColor.value),
      secondaryColor: (0, _cccisdColorPicker.getColor)(secondaryColor.value)
    }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.DragDropContext, {
      onDragEnd: function onDragEnd(result) {
        return _onDragEnd(result, container);
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
      droppableId: "droppable",
      direction: "horizontal"
    }, function (provided, snapshot) {
      return /*#__PURE__*/_react["default"].createElement("div", _extends({}, provided.droppableProps, {
        ref: provided.innerRef,
        style: getListStyle(snapshot.isDraggingOver),
        className: _style["default"].droppable
      }), container.tiles.map(function (tile, index) {
        return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
          draggableId: tile.id.value,
          index: index,
          key: tile.id.value
        }, function (dragProvided, dragSnapshot) {
          return /*#__PURE__*/_react["default"].createElement("div", _extends({
            ref: dragProvided.innerRef
          }, dragProvided.draggableProps, {
            role: "presentation",
            key: 'key' + index,
            style: {
              display: 'flex'
            }
          }), /*#__PURE__*/_react["default"].createElement(_Tile["default"], {
            key: tile.id.value,
            id: tile.id.value,
            text: tile.text,
            icon: tile.icon,
            iconUrl: tile.iconUrl,
            content: tile.content,
            tables: props.tables,
            reports: props.reports,
            tooltip: tile.tooltip,
            container: container,
            dragHandleProps: dragProvided.dragHandleProps,
            icons: props.icons
          }));
        });
      }), provided.placeholder);
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].buttonRight
    }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      trigger: /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-primary",
        style: {
          marginBottom: '0.5em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_plusCircle["default"], null), " Add New Report Tile"),
      title: "Add New Tile",
      render: function render(_ref3) {
        var closeModal = _ref3.closeModal;
        return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
          initialValues: {
            type: 'report'
          },
          onSubmit: function onSubmit(values) {
            return handleAddTile(values, container, closeModal);
          },
          validate: addTileValidate,
          render: function render(_ref4) {
            var values = _ref4.values;
            // console.log(values);
            return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement("div", {
              className: _style["default"].horizontal
            }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
              name: "text",
              component: _cccisdFormik.CccisdInput,
              label: "Name"
            }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
              name: "icon"
            }, function (_ref5) {
              var field = _ref5.field,
                form = _ref5.form;
              return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
                field: field,
                form: form,
                label: "Icon"
              }, /*#__PURE__*/_react["default"].createElement("div", null, iconOptions.map(function (option) {
                return /*#__PURE__*/_react["default"].createElement("button", {
                  key: option.value,
                  type: "button",
                  className: 'btn btn-default ' + (option.value === values.icon ? 'active' : ''),
                  onClick: function onClick() {
                    form.setFieldValue('icon', option.value);
                  }
                }, option.label);
              })));
            }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
              name: "iconUrl"
            }, function (_ref6) {
              var field = _ref6.field,
                form = _ref6.form;
              return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
                field: field,
                form: form,
                label: ""
              }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelResources.ImagePicker, {
                trigger: /*#__PURE__*/_react["default"].createElement("button", {
                  type: "button",
                  className: "btn btn-default"
                }, "Upload image"),
                onChange: function onChange(value) {
                  return form.setFieldValue('iconUrl', value.url);
                }
              }));
            }), values.iconUrl && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("img", {
              src: values.iconUrl,
              alt: "Tile Icon",
              width: "100px",
              height: "100px"
            })), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
              name: "type",
              component: _cccisdFormik.CccisdSelect,
              label: "Type",
              options: tileTemplateTypeOptions
            }), values.type === 'report' && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
              name: "content",
              component: _cccisdFormik.CccisdSelect,
              label: "Content",
              options: _getReportOptions()
            }), values.type === 'table' && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
              name: "content",
              component: _cccisdFormik.CccisdSelect,
              label: "Content",
              options: _getTableOptions()
            }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
              name: "tooltip",
              component: _cccisdFormik.CccisdInput,
              label: "Tooltip"
            }), /*#__PURE__*/_react["default"].createElement("div", {
              className: "form-group"
            }, /*#__PURE__*/_react["default"].createElement("button", {
              className: "btn btn-primary",
              type: "submit"
            }, "Add Tile"))));
          }
        });
      }
    })));
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].buttonRight
  }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    trigger: /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-primary",
      style: {
        marginBottom: '0.5em'
      }
    }, /*#__PURE__*/_react["default"].createElement(_plusCircle["default"], null), " Add New Reports Container"),
    title: "Add New Container",
    render: function render(_ref7) {
      var closeModal = _ref7.closeModal;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
        onSubmit: function onSubmit(values) {
          return handleAddContainer(values, closeModal);
        },
        validate: addContainerValidate,
        render: function render() {
          return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].horizontal
          }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "title",
            component: _cccisdFormik.CccisdInput,
            label: "Title"
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "description",
            component: _cccisdFormik.CccisdTextarea,
            label: "Description"
          }), /*#__PURE__*/_react["default"].createElement("div", {
            className: "form-group"
          }, /*#__PURE__*/_react["default"].createElement("button", {
            className: "btn btn-primary",
            type: "submit"
          }, "Add Container"))));
        }
      });
    }
  })));
};
var _default = exports["default"] = (0, _formWrapper["default"])({
  fields: fields,
  validate: validate
})(ReportCenterForm);